import { UpdateControlMetadata } from '../validators/helpers';

export function BoxedControl(target: any, propertyKey: string) {
  UpdateControlMetadata(target, propertyKey, { boxed: true });
}
